import { GridItem, Stack } from "@octopus-energy/coral/atoms"
import { storyblokEditable } from "@octopus-energy/coral/storyblok"
import { AnimatedNumber, FadeIn, Text } from "@/features/greenEnergy"
import { type SbBlokGreenEnergyConsumed } from "../../types"

interface DynamicRenewableEnergyProps {
    blok: SbBlokGreenEnergyConsumed
}

export function DynamicEnergyConsumed({ blok }: DynamicRenewableEnergyProps) {
    return (
        <GridItem
            gridRowStart={{ base: 5, xl: 3 }}
            gridColumnStart={{ base: 1, xl: 4 }}
            gridRowEnd={{ base: 6, xl: 4 }}
            gridColumnEnd={{ base: 3, xl: 6 }}
        >
            <FadeIn {...storyblokEditable(blok)}>
                <Stack
                    flexDirection="column"
                    gap="none"
                >
                    <Text>{blok.line1}</Text>

                    {blok.thousands && (
                        <AnimatedNumber
                            target={blok.thousands}
                            final={`${blok.thousands} 000`}
                            suffix="&nbsp;000"
                        />
                    )}

                    <Text
                        showcased
                        textAlign={{ base: undefined, xl: "end" }}
                    >
                        {blok.line2}
                    </Text>
                </Stack>
            </FadeIn>
        </GridItem>
    )
}

export default DynamicEnergyConsumed
